import { render, staticRenderFns } from "./CourseListDetailsYw.vue?vue&type=template&id=032d7054&scoped=true"
import script from "./CourseListDetailsYw.vue?vue&type=script&lang=js"
export * from "./CourseListDetailsYw.vue?vue&type=script&lang=js"
import style0 from "./CourseListDetailsYw.vue?vue&type=style&index=0&id=032d7054&prod&lang=less&scoped=true"
import style1 from "./CourseListDetailsYw.vue?vue&type=style&index=1&id=032d7054&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "032d7054",
  null
  
)

export default component.exports